import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface ServicesTableProps {
}

export const ServicesTable: React.FC<ServicesTableProps> = () => {

    const servicesState = useAppSelector(state => state.services);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Nimi</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {servicesState.services.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row.name}
                            </td>
                            <td className="action">
                                <Link to={`/services/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/services/${row.id}/delete`}>Kustuta</Link>
                                {row.client_email || row.vendor_email || row.client_contact_email || row.vendor_contact_email ? (
                                    <>
                                        <span>|</span>
                                        <Link to={`/services/${row.id}/emails`}>E-mailide tekstid</Link>
                                    </>
                                ) : null}
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <ul className="table-actions">
                <li>
                    <Link to="/services/new">
                        <strong>Lisa teenus</strong>
                    </Link>
                </li>
            </ul>
        </>
    );

}